import { RollbackOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Select, Tooltip } from "antd";
import { DatePicker } from "components/";
import { roles } from "constants/index";
import { useTranslation } from "react-i18next";
import { getUser } from "utils/index";

const filterOption = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
export default function InventoryFilter({ form, onFinish, shops, loading }) {
    const { t } = useTranslation()

    return (
        <Form form={form} layout="vertical" onFinish={onFinish}>
            <Row gutter={16}>
                <Col span={6}>
                    <Form.Item name="shop" label={t('shop')} rules={[{ required: true }]}>
                        <Select options={shops} disabled={+getUser().role === roles.shopManager} showSearch allowClear filterOption={filterOption} optionFilterProp="children" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item name="month" label={t('month')} rules={[{ required: true }]}>
                        <DatePicker placeholder='' picker="month" />
                    </Form.Item>
                </Col>
                <Col span={3} offset={18}>
                    <Form.Item>

                        <Tooltip title={t('search')}>
                            <Button loading={loading} style={{ width: "100%" }} htmlType="submit" type="primary">
                                <SearchOutlined />  </Button>
                        </Tooltip>

                    </Form.Item>
                </Col>
                <Col span={3}>
                    <Form.Item>
                        <Tooltip title={t('reset')}>
                            <Button loading={loading} onClick={() => form.resetFields()} style={{ width: "100%" }}>
                                <RollbackOutlined />
                            </Button>
                        </Tooltip>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    )
}